import { render, staticRenderFns } from "./ModalFormWrapper.vue?vue&type=template&id=05dcf7cb"
import script from "./ModalFormWrapper.vue?vue&type=script&lang=js"
export * from "./ModalFormWrapper.vue?vue&type=script&lang=js"
import style0 from "./ModalFormWrapper.vue?vue&type=style&index=0&id=05dcf7cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports